import React, { useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { Panel, Grid, Row, Col, Button, Message } from 'rsuite'
import { isEmpty } from 'lodash-es'
import { startLoading, doneLoading } from '../../utils/loading'
import { saveSendAssignExpertMuti } from '../../redux/actions/assignExpert'
import ConfirmWidget from '../confirm/ConfirmWidget'
import pathname from '../../constants/pathname'
import './styles.less'
import ExpertName from '../../components/view/ExpertName'

export default function SendSelectedExpertMulti({
  schema,
  header,
  selectedExpert,
  projectIdList,
  onComplete = () => {},
}) {
  const SELECTED_EXPERT = 'selectedExpertMulti'

  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState()
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [formSchema, setFormSchema] = useState(schema)
  const history = useHistory()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const handleOnSendAssignExpert = async (request) => {
    startLoading()
    setIsLoading(true)
    setErrorMessage(null)
    try {
      console.log('handleOnSendAssignExpert')
      const _schema = await saveSendAssignExpertMuti(request)
      sessionStorage.removeItem(SELECTED_EXPERT)
      onComplete()
    } catch (e) {
      setErrorMessage('เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ')
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleRequest = () => {
    const itemList = selectedExpert.map((item) => {
      return {
        id: item.id,
        isOnline: item.isOnline,
        isSelected: item.isSelected,
      }
    })
    const body = {
      projectVersionIds: projectIdList,
      itemsList: itemList,
    }
    // console.log(JSON.stringify(body))
    handleOnSendAssignExpert(body)
  }

  const handleSubmit = () => {
    if (isEmpty(selectedExpert)) {
      setErrorMessage(`ต้องการผู้ทรงคุณวุฒิอย่างน้อย 1 คน`)
      return
    }

    setIsShowConfirm(true)
  }

  const onConfirm = () => {
    setIsShowConfirm(false)
    handleRequest()
  }

  const onCancle = () => {
    setIsShowConfirm(false)
  }

  return (
    <>
      <Panel
        className="send-selected-expert"
        shaded
        header={header}
        bordered
        collapsible
        defaultExpanded
      >
        <Grid fluid>
          <Row>
            {selectedExpert?.length < 1 && ( //&& !schema?.forms?.reviewerApproveList?.itemsList?.length > 0
              <Message
                style={{ marginBottom: 10 }}
                showIcon
                type="warning"
                description="ไม่มีรายชื่อผู้ทรงที่เลือกไว้เพื่อส่งพิจราณา กรุณาไปเลือกผู้ทรงคุณวุฒิก่อน"
              />
            )}
          </Row>
          <Row>
            <Col style={{ marginBottom: 20 }} xs={24} sm={24} md={24} lg={24}>
              <h6 className="header">{formSchema.budgetInfo?.header}</h6>
            </Col>
            <Col style={{ marginBottom: 20 }} xs={24} sm={24} md={24} lg={24}>
              <span>{`${formSchema.budgetInfo?.budget.toLocaleString()} บาท`}</span>
            </Col>
            <Col style={{ marginBottom: 20 }} xs={24} sm={24} md={24} lg={24}>
              <Message
                showIcon
                type="warning"
                description={`ต้องการผู้ทรงคุณวุฒิ${formSchema.conditionOfReviewer?.conditionDesc}`}
              />
            </Col>
            {/* <Col style={{ marginBottom: 20 }} xs={24} sm={24} md={24} lg={24}>
              <span>{`ต้องการผู้ทรงคุณวุฒิ${formSchema.conditionOfReviewer?.conditionDesc}`}</span>
            </Col> */}
          </Row>

          <Row>
            {!isEmpty(selectedExpert) &&
              selectedExpert
                .filter((item) => item.isSelected)
                .map((item, index) => (
                  <ExpertName
                    key={item.id}
                    name={`${index + 1}) ${item.name}`}
                    email={item.email}
                    group={item.group}
                    emailMarginLeft={20}
                    reviewType={item.reviewType}
                    showReviewType
                  />
                  // <Col key={item.id} style={{ marginBottom: 10 }} xs={24} sm={24} md={24} lg={24}>
                  //   {`${index + 1}) ${item.name}`}
                  // </Col>
                ))}
            <Col style={{ marginBottom: 10 }} xs={24} sm={24} md={24} lg={24}>
              {!!errorMessage && (
                <Row style={{ marginBottom: 10 }}>
                  <Message showIcon type="error" description={errorMessage} />
                </Row>
              )}
            </Col>
            <Col style={{ marginBottom: 10, textAlign: 'right' }} xs={24} sm={24} md={24} lg={24}>
              <Button
                style={{ width: 130 }}
                appearance="ghost"
                onClick={handleSubmit}
                disabled={isLoading || selectedExpert?.length < 1}
              >
                {'ส่งพิจารณา'}
              </Button>
            </Col>
          </Row>
        </Grid>
        <ConfirmWidget
          title={`ยืนยันการส่งพิจารณา`}
          show={isShowConfirm}
          detail={`กรุณายืนยันการส่งพิจารณา`}
          onCancle={onCancle}
          onConfirm={onConfirm}
        />
      </Panel>
    </>
  )
}
